<template>
  <div class="list-box">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-radio-group v-model="state.params.status" @change="onLoad">
          <el-radio-button>全部</el-radio-button>
          <el-radio-button :value="0">待开票</el-radio-button>
          <el-radio-button :value="1">已开票</el-radio-button>
          <el-radio-button :value="2">审核不通过</el-radio-button>
        </el-radio-group>
        <el-date-picker
          v-model="state.dates"
          type="daterange"
          range-separator="至"
          start-placeholder="--开票日期--"
          end-placeholder="--开票日期--"
          style="width: 400px"
          value-format="YYYY-MM-DD"
          @change="
            (value) => {
              if (value)
                state.params.invoice_date = value[0] + ' - ' + value[1];
            }
          "
          @clear="
            delete state.dates;
            delete state.params.invoice_date;
          "
        />
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
      <el-button
        type="primary"
        :icon="Plus"
        link
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
        v-if="$judge_auth('47')"
        >申请开票
      </el-button>
    </ul>
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column label="状态" sortable="status" width="100">
          <template #default="{ row }">
            <c_status arrName="invoice_status" :value="row.status" />
          </template>
        </el-table-column>
        <el-table-column
          prop="d_invoice_name"
          label="发票类型"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="title"
          label="发票抬头"
          align="center"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="s_unified_social_credit_identifier"
          label="社会统一信用代码"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="d_invoice_type_name"
          label="开票类型"
          :formatter="$tab_TextFormat"
        />
        <el-table-column prop="invoice_nature" label="开票信息" width="180">
          <template #default="{ row }">
            <text v-if="row.invoice_nature == 0">普通发票</text>
            <text style="color: #ffa500" v-else-if="row.invoice_nature == 1"
              >增值税发票</text
            >
            <text v-else>-</text>
          </template>
        </el-table-column>
        <el-table-column prop="d_invoice_kind_name" label="开票种类" />
        <el-table-column prop="amount" label="开票金额" />
        <el-table-column prop="invoice_remark" label="开票备注" />
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showInfo"
      title="申请开票"
      @close="state.showInfo = false"
    >
      <c_Add
        @close="
          state.showInfo = false;
          onLoad();
        "
        :customer_id="props.customer_id"
        :customer_code="props.customer_code"
      ></c_Add>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import { customermine_invoice_list } from "@/http/customer";

import c_Add from "./Add.vue";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
    name: "",
  };
}
export default {
  components: {
    c_Add,
  },
  props: {
    customer_id: Number,
    customer_code: String,
  },
  setup(props) {
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.customer_id = props.customer_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      customermine_invoice_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;

          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      props,
      onLoad,
      onSortChange,
      onReset,
    };
  },
};
</script>
<style scoped></style>
